<template>
  <v-container fluid>
    <v-layout row>
      <v-flex xs12 sm12 md12 lg10 offset-lg1>
        <v-breadcrumbs
          :items="[{ text: 'หน้าแรก', disabled: true }]"
          class="mb-4">
        </v-breadcrumbs>

        <v-layout row>
          <!-- <a href="/ฐานข้อมูลงานวิจัยของอาจารย์.pdf" target="_blank"> -->
          <router-link to="/info/personnel">
            ฐานข้อมูลงานวิจัยและนวัตกรรมของอาจารย์
          </router-link>
          <!-- </a> -->
        </v-layout>
        <v-layout row>
          <a href="/งานวิจัยที่เผยแพร่-2562-2567.pdf" target="_blank">
            การเผยแพร่งานวิจัยและนวัตกรรม
          </a>
        </v-layout>
        <v-layout row>
          <router-link to="/info/all-faculty">
            ระบบสารสนเทศการจัดการงานวิจัยและนวัตกรรม
          </router-link>
        </v-layout>
        <!-- <div>
          <a href="/static/pdf.pdf" target="_blank">การเผยแพร่งานวิจัยและนวัตกรรม</a>
        </div> -->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Home',

  data () {
    return {
      // pdf1: require('@/assets/pdf.pdf')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

table, th, td {
  /* border: solid 1px; */
}

.faculty-click {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue